import { render, staticRenderFns } from "./SeleccionarFecha.vue?vue&type=template&id=10542e9a"
import script from "./SeleccionarFecha.vue?vue&type=script&lang=js"
export * from "./SeleccionarFecha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports